var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIotSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 54.9214,
    y1: 14.2848,
    x2: 47.146,
    y2: 22.2218,
    stroke: "#161614",
    strokeWidth: 3.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1.875,
    x2: 11.111,
    y2: -1.875,
    transform: "matrix(0.699799 0.71434 0.71434 -0.699799 16.7148 12.9727)",
    stroke: "#161614",
    strokeWidth: 3.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.3755,
    y1: 53.4555,
    x2: 23.1509,
    y2: 45.5184,
    stroke: "#161614",
    strokeWidth: 3.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1.875,
    x2: 11.111,
    y2: -1.875,
    transform: "matrix(-0.699799 -0.71434 -0.71434 0.699799 53.582 54.7676)",
    stroke: "#161614",
    strokeWidth: 3.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5723,
    y1: 33.5859,
    x2: 17.062,
    y2: 33.5859,
    stroke: "#161614",
    strokeWidth: 3.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 52.3691,
    y1: 33.5508,
    x2: 56.8588,
    y2: 33.5508,
    stroke: "#161614",
    strokeWidth: 3.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 35.1836,
    y1: 11.7656,
    x2: 35.1836,
    y2: 15.9797,
    stroke: "#161614",
    strokeWidth: 3.75
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 34.7617,
    y1: 51.8906,
    x2: 34.7617,
    y2: 56.1047,
    stroke: "#161614",
    strokeWidth: 3.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.851 52.0263C44.8717 52.0263 52.995 43.9029 52.995 33.8823C52.995 23.8616 44.8717 15.7383 34.851 15.7383C24.8304 15.7383 16.707 23.8616 16.707 33.8823C16.707 43.9029 24.8304 52.0263 34.851 52.0263ZM46.6713 28.4645C47.1487 28.9415 47.0895 29.7168 46.5789 30.1581C46.0684 30.5994 45.3001 30.539 44.8168 30.0679C43.6513 28.932 42.2981 28.0013 40.8141 27.3186C38.9593 26.4654 36.9433 26.0193 34.9017 26.0105C32.8601 26.0017 30.8403 26.4303 28.9782 27.2675C27.4884 27.9374 26.1272 28.8563 24.9519 29.9821C24.4645 30.449 23.6958 30.5028 23.1891 30.0571C22.6823 29.6113 22.6298 28.8356 23.1113 28.3627C24.5213 26.978 26.1677 25.8515 27.976 25.0385C30.1564 24.0581 32.5216 23.5562 34.9123 23.5666C37.3029 23.5769 39.6636 24.0992 41.8355 25.0984C43.6367 25.927 45.2734 27.0676 46.6713 28.4645ZM41.9972 34.1191C42.5173 33.6695 42.5789 32.8772 42.0721 32.4128C41.2555 31.6646 40.3258 31.046 39.3151 30.581C37.9265 29.9422 36.4171 29.6083 34.8886 29.6017C33.3601 29.5951 31.848 29.916 30.4539 30.5428C29.4392 30.999 28.5042 31.6095 27.6812 32.3506C27.1703 32.8106 27.2251 33.6035 27.7413 34.0575C28.2575 34.5115 29.0388 34.4524 29.5656 34.0107C30.1424 33.527 30.7846 33.1236 31.4748 32.8133C32.5445 32.3323 33.7049 32.0861 34.8779 32.0911C36.0508 32.0962 37.209 32.3525 38.2746 32.8427C38.9621 33.159 39.6007 33.5679 40.1734 34.0565C40.6963 34.5028 41.4771 34.5686 41.9972 34.1191ZM34.8371 44.1507C37.172 44.1507 39.0648 42.2579 39.0648 39.923C39.0648 37.5881 37.172 35.6953 34.8371 35.6953C32.5022 35.6953 30.6094 37.5881 30.6094 39.923C30.6094 42.2579 32.5022 44.1507 34.8371 44.1507ZM34.8371 41.6839C33.8646 41.6839 33.0762 40.8955 33.0762 39.923C33.0762 38.9505 33.8646 38.1621 34.8371 38.1621C35.8096 38.1621 36.598 38.9505 36.598 39.923C36.598 40.8955 35.8096 41.6839 34.8371 41.6839Z",
    fill: "#161614"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.54516,
    cy: 8.46899,
    r: 8.46899,
    fill: "#161614"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5159,
    cy: 8.46899,
    r: 8.46899,
    fill: "#161614"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5159,
    cy: 59.3694,
    r: 8.46899,
    fill: "#F30002"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.54516,
    cy: 59.3694,
    r: 8.46899,
    fill: "#161614"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.05351,
    cy: 33.9207,
    r: 6.06523,
    fill: "#F30002"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8621,
    cy: 6.06523,
    r: 6.06523,
    fill: "#F30002"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.6531,
    cy: 33.9207,
    r: 6.06523,
    fill: "#161614"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8621,
    cy: 61.7762,
    r: 6.06523,
    fill: "#F30002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotSecurity);
export default __webpack_public_path__ + "static/media/IOT-Security.c504606b0d1567cdc2a2b53a472ffcaf.svg";
export { ForwardRef as ReactComponent };